import Vue from 'vue';
import Axios from 'axios';
import gsap from 'gsap';

import overview from '@/mixins/overview.js';
import transition_staggered_fade from '@/mixins/transition-staggered-fade-mixin.js';

Vue.component('overview-news-block', {
    mixins: [overview, transition_staggered_fade],
    data() {
        return {
            legislation: null
        };
    },
    created() {
        this.legislation = this.$route.query.legislation
            ? this.$route.query.legislation
            : '';
    },
    methods: {
        getItems() {
            clearInterval(this.elapsed);
            this.loading = true;
            this.searchResults = [];
            const getUrl =
                '/umbraco/api/search/getNewsOverviewContent?q=' +
                this.searchQuery +
                '&page=' +
                this.currentPage +
                this.currentPageId +
                '&itemsPerPage=' +
                this.loadItems +
                '&v=' +
                Date.now() +
                '&legislationId=' +
                this.legislation;

            Axios.get(getUrl).then(response => {
                if (response.status == 200 && response.data.data) {
                    this.searchResults = response.data.data;
                    this.resultsCount = response.data.results;
                    this.emptyResult =
                        response.data.results != 0 ? false : true;
                }
                this.loading = false;
                gsap.to(window, 1, {
                    scrollTo: { y: 0, autoKill: true },
                    delay: 0,
                    ease: 'cubic.easeOut'
                });
            });
        }
    }
});
